import styled, { css } from 'styled-components';
import { getShouldForwardProp } from 'utils/getShouldForwardProp';

export const Header = styled.div.withConfig({
    shouldForwardProp: getShouldForwardProp(['headerColor']),
})<{ headerColor: string }>`
    ${({ headerColor }) => css`
        display: flex;
        flex-direction: row;
        align-items: center;
        color: ${headerColor};
    `}
`;
